import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Button, Spinner } from 'react-bootstrap'
import moment from 'moment'

import * as actions from '../../../actions'
import { reducirCosecha }
  from '../../../../../helpers/cpa'
import { setCerealEspecie } from '../../../../Cereal/actions'
import ValidacionExterna from './ValidacionExterna'
import CamposIngresoCompleto1 from
  '../../../components/iCompleto/CamposIngresoCompleto1'
import { FORM_INGRESO_COMPLETO } from '../../../../../config/forms'
import StatusModal from
  '../../../../Forms/SharedComponents/containers/StatusModal'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../config/settings'

class IngresoCompleto1 extends Component {
  constructor (props) {
    super(props)
    props.setCerealEspecie(props.currentCpa.cereal)
    this.hideValidacionModal = this.hideValidacionModal.bind(this)
  };

  hideValidacionModal () {
    this.props.hideValidacionModal()
  }

  prepareEntities (cpa) {
    const {
      exportador,
      corredorComprador,
      corredorVendedor,
      transportista,
      chofer,
      cuentayorden,
      remitenteComercialProductor,
      remitenteComercialVentaPrimaria,
      remitenteComercialVentaSecundaria
    } = cpa

    // Comentado cuando comenzo la CPE
    // const { titularCp, remitente } = titularRemitente(titularDeCupo, cuentayorden)
    // const remitente = remitenteComercialVentaPrimaria
    const titularCp = cuentayorden

    return {
      searchSet: [
        { entity: 'exportador', value: exportador },
        { entity: 'corredor', value: corredorComprador },
        { entity: 'corredor', value: corredorVendedor },
        { entity: 'transportista', value: transportista },
        { entity: 'chofer', value: chofer },
        { entity: 'cargador', value: titularCp },
        { entity: 'cargador', value: remitenteComercialProductor },
        { entity: 'cargador', value: remitenteComercialVentaPrimaria },
        { entity: 'cargador', value: remitenteComercialVentaSecundaria }
      ],
      fields: ['exportador', 'corredorComprador', 'corredorVendedor',
        'transportista', 'chofer', 'titular', 'remitenteComercialProductor',
        'remitenteComercialVentaPrimaria', 'remitenteComercialVentaSecundaria']
    }
  }

  componentDidMount () {
    const {
      currentCpa: cpa,
      change: formChange,
      iCompletoUpdateEntities
    } = this.props
    formChange('cereal', cpa.cereal)
    formChange('cerealVariedad', cpa.cerealVariedad)
    formChange('pesoBruto', (cpa.pesoNeto + cpa.pesoTara))
    iCompletoUpdateEntities(this.prepareEntities(cpa), formChange)
  };

  render () {
    const {
      handleSubmit,
      onPrev,
      currentCpa = null,
      invalid,
      iCompletoShowValidacionModal,
      iCompletoValidacionResponse,
      iCompletoRequestConfirmarArribo
    } = this.props

    return (
      <div>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <StatusModal
          show={iCompletoShowValidacionModal}
          onClick={this.hideValidacionModal}
          // modifique iCompletoValidacionResponse.message
          errorMessage={
            iCompletoValidacionResponse &&
            iCompletoValidacionResponse
          }
        />
        <div style={{ margin: '2%' }}>
          {currentCpa.numero
            ? <h3>Validación para {currentCpa.numero}</h3>
            : currentCpa.codigoCupo && <h3>Ingreso de CPA para {currentCpa.codigoCupo}</h3>
          }
        </div>

        <CamposIngresoCompleto1 />
        {currentCpa.estadoCtg === null && <ValidacionExterna />}
        {currentCpa.estadoCtg === 'E' && <ValidacionExterna />}
        <h4>
          {currentCpa.estadoCtg === 'V' && `CTG Validado con el N° ${currentCpa.validacionCtg}`}
          {currentCpa.estadoCtg === 'P' && `CTG Postergado`}
        </h4>
        <hr />
        <br />
        <Button
          type='button'
          onClick={() => onPrev()}
          size='lg'
        >Atras</Button>{'  '}
        <Button
          type='submit'
          onClick={() => handleSubmit()}
          disabled={invalid || iCompletoRequestConfirmarArribo}
          size='lg'
        > {iCompletoRequestConfirmarArribo &&
        <Spinner
          as='span'
          animation='border'
          size='sm'
          role='status'
          aria-hidden='true'
        />}
          {' '}
          {!iCompletoRequestConfirmarArribo && <span>Siguiente</span>}
          {iCompletoRequestConfirmarArribo && <span>Confirmando</span>}
        </Button>
        <br />
      </div>
    )
  };
};

const getInitialValues = (state) => {
  const { iCompletoCpa: cpa } = state.camionesIngreso
  return {
    ...cpa,
    cosecha: reducirCosecha(cpa.cosecha),
    fechaDeVencimiento: cpa.fechaDeVencimiento && moment(cpa.fechaDeVencimiento).format('DDMMYY'),
    biotecnologia: cpa.biotecnologiaCereal || 'NO ALEGA'
  }
}

const mapStateToProps = (state) => ({
  initialValues: getInitialValues(state),
  currentCpa: state.camionesIngreso.iCompletoCpa,
  iCompletoValidacionResponse: state.camionesIngreso.iCompletoValidacionResponse,
  iCompletoShowValidacionModal: state.camionesIngreso.iCompletoShowValidacionModal,
  iCompletoRequestConfirmarArribo: state.camionesIngreso.iCompletoRequestConfirmarArribo,
  invalid: isInvalid(FORM_INGRESO_COMPLETO)(state)
})

const withRedux = connect(mapStateToProps,
  { ...actions, setCerealEspecie })

const withReduxForm = reduxForm({
  form: FORM_INGRESO_COMPLETO,
  enableReinitialize: false,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(IngresoCompleto1))
